module.exports = __webpack_public_path__ + "static/media/todos-reminder.c2ac3c32.svg";